import './styles/global';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { ThemeProvider } from 'styled-components';
import theme from './styles';
import { getBrand } from './utils/brand/getBrand';

const App =
  (process.env.REACT_APP_ENTRY || window.REACT_APP_ENTRY) === 'results'
    ? require('./Results').default
    : require('./Content').default;

if (typeof window !== 'undefined') {
  const appElement = document.getElementById('root');
  const { brandId } = getBrand();
  const content = (
    <ThemeProvider theme={theme(brandId)}>
      <App data={window.SERVER_DATA} />
    </ThemeProvider>
  );
  if (process.env.NODE_ENV === 'development') {
    render(content, appElement);
  } else {
    hydrate(content, appElement);
  }
}



// WEBPACK FOOTER //
// ./src/index.js